import { Component, OnInit, Input } from '@angular/core';
import { IToggleEvent, tr } from '@kpd/framework-ngx';
import { RoleService } from 'app/shared/services/role.service';
import { Permissionset } from 'app/shared/models/permissionset';
import { Permission } from 'app/shared/models/permission';
import { PermissionsetService } from 'app/shared/services/permissionset.service';
import { PermissionsetKey } from 'app/shared/models/keys/permissionset-key';

interface IApplicationWithRoles {
  name: string;
  roles: IUserRoleWithPermissionSets[];
}

interface IUserRoleWithPermissionSets {
  role: string;
  loading: boolean;
  permissionSets?: IPermissionSet[];
}

interface IPermissionSet {
  name: string;
  permissions?: { name: string; isDeprecated: boolean }[];
  isGlobal: boolean;
  loading: boolean;
}

@Component({
  selector: 'app-user-details-permissions-application',
  templateUrl: './user-details-permissions-application.component.html',
})
export class UserDetailsPermissionsApplicationComponent implements OnInit {
  @Input()
  application: IApplicationWithRoles;
  constructor(private roleService: RoleService, private permissionsetService: PermissionsetService) {}
  noPermissionSets = tr('No permission sets linked to this role');
  noPermissions = tr('No permissions linked to this permission set');
  ngOnInit(): void {}

  onRoleCollapseChange(event: IToggleEvent, role: IUserRoleWithPermissionSets): void {
    if (!event.collapsed && !role.permissionSets) {
      role.loading = true;
      this.roleService.getRoleWithPermissionSets(this.application.name, role.role).subscribe(roleWithPermissionSets => {
        role.permissionSets = (roleWithPermissionSets.permissionSets as Permissionset[]).map(p => {
          return {
            name: p.name,
            loading: false,
            isGlobal: p.scope === 'global',
            type: p.type,
          };
        });
        role.loading = false;
      });
    }
  }

  onPermissionSetCollapseChange(event: IToggleEvent, permissionSet: IPermissionSet): void {
    if (!event.collapsed && !permissionSet.permissions) {
      permissionSet.loading = true;
      this.permissionsetService
        .getById(new PermissionsetKey(permissionSet.name, this.application.name, permissionSet.isGlobal))
        .subscribe((permissionSetWithPermissions: Permissionset) => {
          if (permissionSetWithPermissions) {
            permissionSet.permissions = (permissionSetWithPermissions.permissions as Permission[]).map(p => ({
              name: p.name,
              isDeprecated: p.isDeprecated,
              deprecatedMessage: p.deprecatedMessage,
            }));
            permissionSet.loading = false;
          }
        });
    }
  }
}
